/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "skills";

export interface WaitForVehicleStopActionArgs {
  /** Timeout to wait until the action fails */
  timeoutS: number;
  /** Vehicle has successfully come to a stop for this duration for the action to succeed */
  settleDurationS: number;
  /** Velocity tolerance to consider the vehicle stopped */
  velTol: number;
  /** [rad/s] */
  angvelTol: number;
}

export interface WaitForVehicleStopResultData {
}

export interface WaitForVehicleStopActionStateData {
}

function createBaseWaitForVehicleStopActionArgs(): WaitForVehicleStopActionArgs {
  return { timeoutS: 0, settleDurationS: 0, velTol: 0, angvelTol: 0 };
}

export const WaitForVehicleStopActionArgs = {
  encode(message: WaitForVehicleStopActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.timeoutS !== 0) {
      writer.uint32(13).float(message.timeoutS);
    }
    if (message.settleDurationS !== 0) {
      writer.uint32(21).float(message.settleDurationS);
    }
    if (message.velTol !== 0) {
      writer.uint32(29).float(message.velTol);
    }
    if (message.angvelTol !== 0) {
      writer.uint32(37).float(message.angvelTol);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): WaitForVehicleStopActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWaitForVehicleStopActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 13) {
            break;
          }

          message.timeoutS = reader.float();
          continue;
        case 2:
          if (tag !== 21) {
            break;
          }

          message.settleDurationS = reader.float();
          continue;
        case 3:
          if (tag !== 29) {
            break;
          }

          message.velTol = reader.float();
          continue;
        case 4:
          if (tag !== 37) {
            break;
          }

          message.angvelTol = reader.float();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WaitForVehicleStopActionArgs {
    return {
      timeoutS: isSet(object.timeoutS) ? globalThis.Number(object.timeoutS) : 0,
      settleDurationS: isSet(object.settleDurationS) ? globalThis.Number(object.settleDurationS) : 0,
      velTol: isSet(object.velTol) ? globalThis.Number(object.velTol) : 0,
      angvelTol: isSet(object.angvelTol) ? globalThis.Number(object.angvelTol) : 0,
    };
  },

  toJSON(message: WaitForVehicleStopActionArgs): unknown {
    const obj: any = {};
    if (message.timeoutS !== 0) {
      obj.timeoutS = message.timeoutS;
    }
    if (message.settleDurationS !== 0) {
      obj.settleDurationS = message.settleDurationS;
    }
    if (message.velTol !== 0) {
      obj.velTol = message.velTol;
    }
    if (message.angvelTol !== 0) {
      obj.angvelTol = message.angvelTol;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WaitForVehicleStopActionArgs>, I>>(base?: I): WaitForVehicleStopActionArgs {
    return WaitForVehicleStopActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WaitForVehicleStopActionArgs>, I>>(object: I): WaitForVehicleStopActionArgs {
    const message = createBaseWaitForVehicleStopActionArgs();
    message.timeoutS = object.timeoutS ?? 0;
    message.settleDurationS = object.settleDurationS ?? 0;
    message.velTol = object.velTol ?? 0;
    message.angvelTol = object.angvelTol ?? 0;
    return message;
  },
};

function createBaseWaitForVehicleStopResultData(): WaitForVehicleStopResultData {
  return {};
}

export const WaitForVehicleStopResultData = {
  encode(_: WaitForVehicleStopResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): WaitForVehicleStopResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWaitForVehicleStopResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): WaitForVehicleStopResultData {
    return {};
  },

  toJSON(_: WaitForVehicleStopResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<WaitForVehicleStopResultData>, I>>(base?: I): WaitForVehicleStopResultData {
    return WaitForVehicleStopResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WaitForVehicleStopResultData>, I>>(_: I): WaitForVehicleStopResultData {
    const message = createBaseWaitForVehicleStopResultData();
    return message;
  },
};

function createBaseWaitForVehicleStopActionStateData(): WaitForVehicleStopActionStateData {
  return {};
}

export const WaitForVehicleStopActionStateData = {
  encode(_: WaitForVehicleStopActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): WaitForVehicleStopActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWaitForVehicleStopActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): WaitForVehicleStopActionStateData {
    return {};
  },

  toJSON(_: WaitForVehicleStopActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<WaitForVehicleStopActionStateData>, I>>(
    base?: I,
  ): WaitForVehicleStopActionStateData {
    return WaitForVehicleStopActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WaitForVehicleStopActionStateData>, I>>(
    _: I,
  ): WaitForVehicleStopActionStateData {
    const message = createBaseWaitForVehicleStopActionStateData();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
